import styled from 'styled-components';

export const RISpecificationStyles = styled.section``;
